import { makeStyles } from '@material-ui/core';
import React, { FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import BlankImage from 'src/components/Icon/BlankImage';
import colorRectangle from 'src/images/colorRectangle.png';
import { editBg } from 'src/store/modules/imageUpload';

const useStyles = makeStyles(() => ({
  wrapper: {
    marginTop: '0.5rem',
    padding: '0.5rem',

    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
    border: '1px solid #D9D9D9'
  },

  boxWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem'
  },
  roundWrapper: {
    width: '1.25rem',
    height: '1.25rem',
    padding: '0.15625rem',
    borderRadius: 999,
    border: '1px solid #000'
  },
  round: {
    width: '100%',
    height: '100%',
    borderRadius: 999,
    backgroundColor: '#000'
  },
  fontWrapper: {
    cursor: 'pointer',

    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem'
  },

  buttonImage: {
    maxWidth: '1.5rem',
    minWidth: '1.5rem',
    maxHeight: '1.5rem',
    minHeight: '1.5rem'
  },
  text: {
    color: '#000',
    fontFamily: 'Roboto',
    fontSize: '0.75rem',
    fontStyle: 'normal',
    fontWeight: 400
  }
}));

const BgPicker: FC<any> = ({ type, onClose }) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const bg = useSelector((state: any) => state.imageUpload.bg);

  return (
    <div className={classes.wrapper}>
      <div className={classes.boxWrapper}>
        <div
          className={classes.fontWrapper}
          onClick={() => {
            const newBg = JSON.parse(JSON.stringify(bg));
            newBg[type] = 'color';
            dispatch(editBg(newBg));
            onClose();
          }}
        >
          <img
            alt="color"
            src={colorRectangle}
            className={classes.buttonImage}
          />
          <span className={classes.text}>SELECT COLOR</span>
        </div>
        <div
          className={classes.fontWrapper}
          onClick={() => {
            const newBg = JSON.parse(JSON.stringify(bg));
            newBg[type] = 'image';
            dispatch(editBg(newBg));
            onClose();
          }}
        >
          <BlankImage stroke="#D9D9D9" />
          <span className={classes.text}>SELECT IMAGE</span>
        </div>
      </div>
    </div>
  );
};

export default BgPicker;
